import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 7c0 .414.336.75.75.75h16.5a.75.75 0 0 0 0-1.5H3.75A.75.75 0 0 0 3 7m0 5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 0-1.5H3.75A.75.75 0 0 0 3 12m0 5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 0-1.5H3.75A.75.75 0 0 0 3 17",
    clipRule: "evenodd"
  }));
}
var IcMenu = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMenu));

export { IcMenu as I };
